<template>
  <div class="edit-password" @contextmenu.stop>
    <el-dialog
      title="修改密码"
      width="450px"
      height="300px"
      top="calc( 50vh - 150px )"
      custom-class="edit-share"
      center
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      :handleCancel="handleCancel"
    >
      <div class="setting-container" ref="ruleForm" :show-message="true">
        <div class="password-item">
          <div class="title"><span class="red">*</span> 原密码</div>
          <el-input type="password" v-model="origin" placeholder="请输入您原登录密码"></el-input>
        </div>
        <div class="password-item">
          <div class="title"><span class="red">*</span> 新密码</div>
          <el-input type="password" v-model="newPassword" placeholder="请输入新密码"></el-input>
        </div>
        <div class="password-item">
          <div class="title"><span class="red">*</span> 再次输入</div>
          <el-input type="password" v-model="confirmPassword" placeholder="请再次输入新密码"></el-input>
        </div>
      </div>
      <a class="forget-password" :href="href">忘记密码</a>
      <div class="default-edit-footer" id="edit-footer">
        <div class="edit-footer-item right" @click="handleCancel()">取消</div>
        <div class="edit-footer-item left" @click="save()">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'PasswordDialog',
  data() {
    return {
      dialogVisible: false,
      origin: '',
      newPassword: '',
      confirmPassword: '',
      href: window.location.origin + '/toResetPassword.jhtml?service=' + window.encodeURIComponent(window.location.href),
      rules: {
        origin: [{ required: true, message: '不能为空' }],
        newPassword: [{ required: true, message: '不能为空' }],
        confirmPassword: [{ required: true, message: '不能为空' }]
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.origin = ''
        this.newPassword = ''
        this.confirmPassword = ''
      }
    }
  },
  computed: {
    userName() {
      return localStorage.getItem('username')
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    save() {
      if (this.originPsw === '' || this.newPassword === '' || this.confirmPassword === '') {
        this.$message({
          message: '密码不能为空',
          type: 'error'
        })
        return
      }
      if (this.newPassword != this.confirmPassword) {
        this.$message({
          message: '确认密码不一致',
          type: 'error'
        })
        return
      }
      this.$emit('savePassword', this.origin, this.newPassword)
    }
  }
}
</script>
<style lang="scss" scoped>
.setting-container {
  margin: 0 auto;
  padding: 0 30px;
  .password-item {
    margin-bottom: 10px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    .title {
      width: 80px;
      .red {
        color: #df5813;
      }
    }
    .el-form-item {
      margin-bottom: 5px;
    }
  }
}
.forget-password {
  color: #df5813;
  font-size: 12px;
  margin-left: 300px;
}
.default-edit-footer {
  height: 50px;
  line-height: 36px;
  font-size: 14px;
  padding-top: 10px;
  background-color: #ffffff;
  text-align: center;

  .edit-footer-item {
    cursor: pointer;
    display: inline-block;
    height: 36px;
    border: 1px solid #df5813;
    text-align: center;
    width: 100px;
    &.left {
      background-color: #df5813;
      color: #fff;
    }
    &.right {
      margin-right: 30px;
    }
  }
}
</style>
